import {
  type ChipVariant, type CommandResult, type CommandScope, type CommandStatus, type ExecutionStatus, type IRemoteCommandExecution
} from './RemoteCommandExecutionLogs';

// Add the product type or the command here to enable the execution logs for it
export const EXECUTION_LOG_COMMANDS: Record<string, string[]> = {
  'Harmony Gen2.0': ['ftp_peripheral_card_sw_update', 'ftp_config_file_update', 'ftp_certificate_upgrade', 'ftp_log_upload'],
};

export const POLL_INTERVAL_MS = 10 * 1000;

export const UNIT_NAME_BY_SCOPE: Partial<Record<CommandScope, string>> = {
  Connector: 'Connector',
  SMR: 'SMR',
};

export const EXECUTION_STATUS_CHIP: Record<ExecutionStatus, { label: string, variant: ChipVariant }> = {
  NotPerformed: { label: 'Not Performed', variant: 'not-performed' },
  NotStarted: { label: 'Not Started', variant: 'pending' },
  InProgress: { label: 'In Progress', variant: 'in-progress' },
  Completed: { label: 'Completed', variant: 'completed' },
  Timeout: { label: 'Timed Out', variant: 'failed' },
};

export const COMMAND_RESULT_BY_STATUS: Record<CommandStatus, CommandResult> = {
  Idle: 'Pending',
  Downloading: 'In Progress',
  Downloaded: 'In Progress',
  Installing: 'In Progress',
  Uploading: 'In Progress',
  Installed: 'Success',
  Uploaded: 'Success',
  DownloadFailed: 'Failed',
  InstallFailed: 'Failed',
  UploadFailed: 'Failed',
  CommandFailed: 'Failed',
};

export const CHIP_VARIANT_BY_RESULT: Record<CommandResult, ChipVariant> = {
  'Pending': 'pending',
  'In Progress': 'in-progress',
  'Success': 'success',
  'Failed': 'failed',
};

export const isExecutionFinished = (execution: IRemoteCommandExecution | null): boolean => {
  return execution?.executionStatus === 'Completed' || execution?.executionStatus === 'Timeout';
};
